﻿import {DateOnly} from "@2d-front-monorepo/core";

export function normalizeYearMonth(year: number, month: number): [number, number] {
	if (month < 1) {
		--year;
		month = 12;
	} else if (month > 12) {
		++year;
		month = 1;
	}

	return [year, month];
}

export function getDateInfo(year: number, month: number, firstDayOfWeek: number): DateInfo {
	[year, month] = normalizeYearMonth(year, month);

	const f = DateOnly.fromComponents(year, month, 1);
	let offset = f.getDayOfWeek() - firstDayOfWeek;
	offset = offset < 0 ? offset + 7 : offset;

	let lastOfMonth = f.getLastOfMonth();

	return {
		offset,
		lastOfMonth,
		lastDay: lastOfMonth + offset,
		month,
		year
	}
}

interface DateInfo {
	year: number;
	month: number;
	offset: number;
	lastDay: number;
	lastOfMonth: number;
}
